module.exports = __webpack_public_path__ + "static/media/nav-icon-bars-inactive.fb7caf1f.svg";